module.exports = __webpack_public_path__ + "img/payback.d5d4a44b.png";